import React, { useEffect, useRef, useState } from 'react';
import './asideNav.css';
import logo from '../../../../assets/images/Logo-no-bg.png';
import {
  Link,
  NavLink,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { LuLayoutDashboard } from 'react-icons/lu';
import { GrConfigure } from 'react-icons/gr';
import { FaChevronDown } from 'react-icons/fa';
import { FaDirections } from 'react-icons/fa';
import { MdDeliveryDining } from 'react-icons/md';
import { RiProhibitedLine } from 'react-icons/ri';
import { MdMergeType } from 'react-icons/md';
import { FaCity } from 'react-icons/fa6';
import { FaFlag } from 'react-icons/fa';
import { MdOutlineDisplaySettings } from 'react-icons/md';
import { HiUserGroup } from 'react-icons/hi2';
import { MdOutlineDevices } from 'react-icons/md';
import { RxDimensions } from 'react-icons/rx';
import { MdLocalOffer } from 'react-icons/md';
import { BiSolidOffer } from 'react-icons/bi';
import { LuPackagePlus } from 'react-icons/lu';
import { TbCategory2 } from 'react-icons/tb';
import { MdOutlineCategory } from 'react-icons/md';
import { IoIosBarcode } from 'react-icons/io';
import { FaSitemap } from 'react-icons/fa6';
import { IoPerson } from 'react-icons/io5';
import { FaMoneyBillWave } from 'react-icons/fa6';
import { FaBarcode } from 'react-icons/fa6';
import { LuPrinter } from 'react-icons/lu';
import { MdOutlinePayments } from 'react-icons/md';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { MdCorporateFare } from 'react-icons/md';
import { HiOutlineReceiptTax } from 'react-icons/hi';
import { FaWeightHanging } from 'react-icons/fa6';
import { GrDeliver } from 'react-icons/gr';
import { IoScan } from 'react-icons/io5';
import { LuGitBranchPlus } from 'react-icons/lu';
import { GoIssueClosed } from 'react-icons/go';
import { MdOutlineContactMail } from 'react-icons/md';
import { MdOutlineHistory } from 'react-icons/md';
import formateText from '../../../../utils/Formate';
import { BsBox } from 'react-icons/bs';
import { RiLockPasswordLine } from 'react-icons/ri';
import { IoTicket } from 'react-icons/io5';
import { FaBoxOpen, FaWalking } from 'react-icons/fa';
import { FaTruck } from 'react-icons/fa6';
import { LuScanLine } from 'react-icons/lu';
import { AiOutlineEuro } from 'react-icons/ai';
import { FaCodeBranch } from 'react-icons/fa';
import { MdOutlinePriceChange } from 'react-icons/md';
import { MdPlace } from 'react-icons/md';
import { TbRulerMeasure } from 'react-icons/tb';
import { AiOutlineStock } from 'react-icons/ai';
import { MdOutlinePayment } from 'react-icons/md';
import { MdOutlineAnalytics } from 'react-icons/md';
import { MdOutlineInsights } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';
import { MdChecklist } from 'react-icons/md';
import { MdTimeline } from 'react-icons/md';
import { MdPeopleOutline } from 'react-icons/md';
import ToggleButton from '../../../sharedComponents/navbar/sub_component/ToggleButton';
import GetLocalStorageUserId from '../../../sharedComponents/GetLocalStorageuserId';
import { toast } from 'react-toastify';
import NotificationBell from '../../../sharedComponents/notifications/NotificationBell';
import SignalRConnectionPill from '../../../sharedComponents/notifications/SignalRConnectionPill';
import { usePermission } from '../../../../context/PermissionContext';
import {
  canAccessCrm,
  canAccessDeliverySetup,
  setupSlugToScreenCode,
} from '../../../../utils/permissionScreens';
import { crmActivityLogout } from '../../../../api/crmApi';
import {
  getWhatsAppInboxUnread,
  WA_INBOX_UNREAD_EVENT,
} from '../Crm/whatsAppInboxBadge';

const AsideNav = () => {
  const { canView } = usePermission();
  const [showAside, setShowAside] = useState(false);
  const [toggleBtnChecked, setToggleBtnChecked] = useState(false);
  const [waInboxUnread, setWaInboxUnread] = useState(() => getWhatsAppInboxUnread());
  const ToggleEventHandler = (e) => {
    e.stopPropagation();
    setShowAside(e.target.checked);
    setToggleBtnChecked(e.target.checked);
  };

  useEffect(() => {
    const sync = (event) => {
      const count = Number(event?.detail?.count);
      setWaInboxUnread(
        Number.isFinite(count) ? count : getWhatsAppInboxUnread(),
      );
    };
    window.addEventListener(WA_INBOX_UNREAD_EVENT, sync);
    setWaInboxUnread(getWhatsAppInboxUnread());
    return () => window.removeEventListener(WA_INBOX_UNREAD_EVENT, sync);
  }, []);
  const Routes = [
    {
      to: 'courier-current-stock',
      name: 'Courier Current stock',
      icon: <AiOutlineStock />,
    },
    {
      to: 'sub-branch',
      name: 'Sub-Branch',
      icon: <FaCodeBranch />,
    },
    {
      to: 'agent-transport',
      name: 'Agent Transport',
      icon: <FaTruck />,
    },
    {
      to: 'parcel-status',
      name: 'Parcel Status',
      icon: <FaBoxOpen />,
    },
    {
      to: 'route',
      name: 'Routes',
      icon: <FaDirections />,
    },
    {
      to: 'agent',
      name: 'Agent',
      icon: <IoPerson />,
    },
    {
      to: 'scanning-point',
      name: 'Scanning Point',
      icon: <IoScan />,
    },
    {
      to: 'city',
      name: 'City',
      icon: <FaCity />,
    },
    {
      to: 'country',
      name: 'Country',
      icon: <FaFlag />,
    },
    {
      to: 'aditional-cost',
      name: 'Additional cost',
      icon: <FaMoneyBillWave />,
    },
    // {
    //   to: "barcode",
    //   name: "Barcode",
    //   icon: <FaBarcode />,
    // },
    // {
    //   to: "barcode-details",
    //   name: "Barcode details",
    //   icon: <IoIosBarcode />,
    // },

    {
      to: 'prohibited-item',
      name: 'Prohibited item',
      icon: <RiProhibitedLine />,
    },
    {
      to: 'shiping',
      name: 'Shiping service',
      icon: <MdDeliveryDining />,
    },
    {
      to: 'cargo-type',
      name: 'Cargo types',
      icon: <MdMergeType />,
    },
    // {
    //   to: "company",
    //   name: "Company",
    //   icon: <MdCorporateFare />,
    // },
    {
      to: 'pickup',
      name: 'Pickup',
      icon: <GrDeliver />,
    },
    {
      to: 'measurement-unit',
      name: 'Measurement unit',
      icon: <TbRulerMeasure />,
    },
    {
      to: 'delivery-plan',
      name: 'Delivery plan',
      icon: <MdDeliveryDining />,
    },
    {
      to: 'weight',
      name: 'Weight',
      icon: <FaWeightHanging />,
    },
    {
      to: 'carrier-partner-point',
      name: 'Point names',
      icon: <MdPlace />,
    },
    {
      to: 'vat-configuration',
      name: 'Vat configuration',
      icon: <HiOutlineReceiptTax />,
    },

    // {
    //   to: "departmental-operation",
    //   name: "Def. operation",
    //   icon: <MdOutlineDisplaySettings />,
    // },
    // {
    //   to: "department",
    //   name: "Department",
    //   icon: <HiUserGroup />,
    // },
    {
      to: 'device',
      name: 'Device',
      icon: <MdOutlineDevices />,
    },
    {
      to: 'dimension',
      name: 'Dimension',
      icon: <RxDimensions />,
    },
    // {
    //   to: "offer",
    //   name: "Discounted offer",
    //   icon: <MdLocalOffer />,
    // },
    // {
    //   to: "offer-details",
    //   name: "Discounted offer details",
    //   icon: <BiSolidOffer />,
    // },
    {
      to: 'extra-packaging',
      name: 'Extra packaging',
      icon: <LuPackagePlus />,
    },
    {
      to: 'item-category',
      name: 'Item category',
      icon: <MdOutlineCategory />,
    },
    // {
    //   to: "function",
    //   name: "Function",
    //   icon: <TbCategory2 />,
    // },
    {
      to: 'item-type',
      name: 'Item type',
      icon: <FaSitemap />,
    },
    {
      to: 'branch',
      name: 'Branch',
      icon: <LuGitBranchPlus />,
    },
  ];

  const deliverySetupSlugs = [
    'route',
    'measurement-unit',
    'dimension',
    'item-category',
    'delivery-plan',
    'weight',
    'item-type',
  ];
  const deliverySetupItems = deliverySetupSlugs
    .map((slug) => Routes.find((item) => item.to === slug))
    .filter(Boolean);
  const otherSetupItems = Routes.filter(
    (item) => !deliverySetupSlugs.includes(item.to),
  ).sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name < b.name) return -1;
    return 0;
  });

  const [dropDown, setDropDown] = useState(false);
  const [dropDownDeliverySetup, setDropDownDeliverySetup] = useState(false);
  const [settingsDropDown, setSettingsDropDown] = useState(false);
  const [crmDropDown, setCrmDropDown] = useState(false);

  const url = useLocation();
  const isDeliverySetupPath = deliverySetupSlugs.some((slug) =>
    url.pathname.includes(`setup/${slug}`),
  ) || url.pathname.includes('setup/delivery-setup');

  useEffect(() => {
    if (url.pathname.includes('setup/')) {
      setDropDown(true);
    } else {
      setDropDown(false);
    }

    setDropDownDeliverySetup(isDeliverySetupPath);

    if (url.pathname.includes('settings/')) {
      setSettingsDropDown(true);
    } else {
      setSettingsDropDown(false);
    }

    setCrmDropDown(url.pathname.includes('/crm/'));
  }, [url, isDeliverySetupPath]);

  // route change handle.

  const NavBarhandle = () => {
    setToggleBtnChecked(false);
    setShowAside(false);
  };

  const navItemClass = ({ isActive }) =>
    `admin-nav-item${isActive ? ' is-active' : ''}`;
  const move = useNavigate();
  const logoutHandle = async () => {
    await crmActivityLogout();
    toast.success('Logout Successfull', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
    localStorage.removeItem('sundorbonBookingUserDetails');
    localStorage.removeItem('token');
    move('/');
  };

  const visibleSetup = otherSetupItems.filter((item) =>
    canView(setupSlugToScreenCode(item.to)),
  );
  const visibleDeliverySetup = deliverySetupItems.filter((item) =>
    canView(setupSlugToScreenCode(item.to)),
  );
  const showDeliverySetup =
    visibleDeliverySetup.length > 0 || canAccessDeliverySetup(canView);
  const showSetup = visibleSetup.length > 0 || showDeliverySetup;
  const showSettings =
    canView('settings.tracking-integration') || canView('roles-permissions');
  const showCrm = canAccessCrm(canView);

  const renderNav = () => (
    <>
      {canView('dashboard') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'/admin-dashboard'}
      >
        <LuLayoutDashboard />
        Dashboard
      </NavLink>
      )}
      {canView('analytics') && (
      <NavLink
        onClick={NavBarhandle}
        className={navItemClass}
        to={'analytics'}
      >
        <MdOutlineInsights />
        Analytics
      </NavLink>
      )}
      {showSetup && (
      <>
      <button
        onClick={() => setDropDown((prev) => !prev)}
        className={`admin-nav-item justify-between ${
          dropDown || url.pathname.includes('setup/') ? 'is-open' : ''
        }`}
      >
        <span className='flex items-center gap-3'>
          <GrConfigure /> Set-up
        </span>{' '}
        <FaChevronDown
          className={`${dropDown ? 'rotate-180' : ''} duration-300`}
        />
      </button>
      <ul
        className={`admin-nav-sub w-full ${dropDown ? 'block' : 'hidden'}`}
      >
        {showDeliverySetup && (
          <>
            <button
              type='button'
              onClick={() => setDropDownDeliverySetup((prev) => !prev)}
              className={`admin-nav-item justify-between ${
                dropDownDeliverySetup || isDeliverySetupPath ? 'is-open' : ''
              }`}
            >
              <span className='flex items-center gap-3'>
                <MdDeliveryDining /> Delivery Setup
              </span>
              <FaChevronDown
                className={`${dropDownDeliverySetup ? 'rotate-180' : ''} duration-300`}
              />
            </button>
            <ul
              className={`admin-nav-nested w-full ${
                dropDownDeliverySetup ? 'block' : 'hidden'
              }`}
            >
              <NavLink
                onClick={NavBarhandle}
                className={navItemClass}
                to={'setup/delivery-setup'}
              >
                <MdOutlineDisplaySettings />
                Overview
              </NavLink>
              {visibleDeliverySetup.map((item) => (
                <NavLink
                  onClick={NavBarhandle}
                  key={item.to}
                  className={navItemClass}
                  to={'setup/' + item.to}
                >
                  {item.icon}
                  {formateText(item.name)}
                </NavLink>
              ))}
            </ul>
          </>
        )}
        {visibleSetup.map((item, idx) => {
          return (
            <NavLink
              onClick={NavBarhandle}
              key={idx}
              className={navItemClass}
              to={'setup/' + item.to}
            >
              {item.icon}
              {formateText(item.name)}
            </NavLink>
          );
        })}
      </ul>
      </>
      )}
      {canView('issue') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'issue'}
      >
        <GoIssueClosed />
        Issue
      </NavLink>
      )}
      {canView('inquiry') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'inquiry'}
      >
        <MdOutlineContactMail />
        Inquiry
      </NavLink>
      )}
      {showCrm && (
      <>
      <button
        type='button'
        onClick={() => setCrmDropDown((prev) => !prev)}
        className={`admin-nav-item justify-between ${
          crmDropDown || url.pathname.includes('/crm/') ? 'is-open' : ''
        }`}
      >
        <span className='flex items-center gap-3'>
          <HiUserGroup /> CRM
        </span>
        <FaChevronDown
          className={`${crmDropDown ? 'rotate-180' : ''} duration-300`}
        />
      </button>
      <ul className={`admin-nav-sub w-full ${crmDropDown ? 'block' : 'hidden'}`}>
        {canView('crm.dashboard') && (
        <NavLink onClick={NavBarhandle} className={navItemClass} to={'crm/dashboard'}>
          <MdOutlineInsights /> Dashboard
        </NavLink>
        )}
        {canView('crm.queries') && (
        <NavLink onClick={NavBarhandle} className={navItemClass} to={'crm/queries'}>
          <MdPeopleOutline /> Leads
        </NavLink>
        )}
        {canView('crm.orders') && (
        <NavLink onClick={NavBarhandle} className={navItemClass} to={'crm/orders'}>
          <MdOutlineHistory /> Orders
        </NavLink>
        )}
        {canView('crm.tasks') && (
        <NavLink onClick={NavBarhandle} className={navItemClass} to={'crm/tasks'}>
          <MdChecklist /> Tasks
        </NavLink>
        )}
        {canView('crm.activity') && (
        <NavLink onClick={NavBarhandle} className={navItemClass} to={'crm/activity'}>
          <MdTimeline /> Activity
        </NavLink>
        )}
        {canView('crm.inbox') && (
        <NavLink onClick={NavBarhandle} className={navItemClass} to={'crm/inbox'}>
          <FaWhatsapp /> Inbox
          {waInboxUnread > 0 ? (
            <span className="wa-inbox-nav-badge" aria-label={`${waInboxUnread} new`}>
              {waInboxUnread > 99 ? '99+' : waInboxUnread}
            </span>
          ) : null}
        </NavLink>
        )}
      </ul>
      </>
      )}
      {canView('bookings') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'bookings'}
      >
        <MdOutlineHistory />
        Bookings
      </NavLink>
      )}
      {canView('walk-in-booking') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'walk-in-booking'}
      >
        <FaWalking />
        Walk-in Booking
      </NavLink>
      )}
      {canView('carrier-partner') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'/admin-dashboard/carrier-partner'}
      >
        <FaTruck />
        Carrier Partner
      </NavLink>
      )}
      {canView('invoice-manager') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'invoice-manager'}
      >
        <FaFileInvoiceDollar />
        Invoice Manager
      </NavLink>
      )}
      {canView('payment') && (
      <NavLink
        onClick={NavBarhandle}
        end
        className={navItemClass}
        to={'payment'}
      >
        <MdOutlinePayments />
        Payment
      </NavLink>
      )}

      {showSettings && (
      <>
      <button
        onClick={() => setSettingsDropDown((prev) => !prev)}
        className={`admin-nav-item justify-between ${
          settingsDropDown || url.pathname.includes('settings/') ? 'is-open' : ''
        }`}
      >
        <span className='flex items-center gap-3'>
          <MdOutlineAnalytics /> Settings
        </span>
        <FaChevronDown
          className={`${settingsDropDown ? 'rotate-180' : ''} duration-300`}
        />
      </button>
      <ul
        className={`admin-nav-sub w-full ${
          settingsDropDown ? 'block' : 'hidden'
        }`}
      >
        {canView('settings.tracking-integration') && (
        <NavLink
          onClick={NavBarhandle}
          className={navItemClass}
          to={'settings/tracking-integration'}
        >
          <MdOutlineAnalytics />
          Tracking / Integration
        </NavLink>
        )}
        {canView('roles-permissions') && (
        <NavLink
          onClick={NavBarhandle}
          className={navItemClass}
          to={'settings/roles-permissions'}
        >
          <RiLockPasswordLine />
          Roles & permissions
        </NavLink>
        )}
      </ul>
      </>
      )}

      {canView('agent-box-assign') && (
      <NavLink
        onClick={NavBarhandle}
        className={navItemClass}
        to={'agent-box-ssign'}
      >
        <BsBox />
        Agent Box Assign
      </NavLink>
      )}

      {canView('parcel-status-scan') && (
      <NavLink
        onClick={NavBarhandle}
        className={navItemClass}
        to={'parcel-status-scan'}
      >
        <LuScanLine />
        Parcel Status Scan
      </NavLink>
      )}
      {canView('parcel-setup-cost') && (
      <NavLink
        onClick={NavBarhandle}
        className={navItemClass}
        to={'parcel-setup-cost'}
      >
        <MdOutlinePriceChange />
        Parcel Setup Cost
      </NavLink>
      )}

      {canView('transport-agent-assigning') && (
      <NavLink
        onClick={NavBarhandle}
        className={navItemClass}
        to={'transport-agent-assigning'}
      >
        <AiOutlineEuro />
        Transport Agent Assigning
      </NavLink>
      )}

      {canView('print-box-serial-barcode') && (
      <NavLink
        onClick={NavBarhandle}
        className={navItemClass}
        to={'print-box-serial-barcode'}
      >
        <FaBarcode />
        Print Box Serial Barcode
      </NavLink>
      )}

      {canView('print-barcode') && (
      <NavLink
        onClick={NavBarhandle}
        className={navItemClass}
        to={'print-barcode'}
      >
        <LuPrinter />
        Print Barcode
      </NavLink>
      )}
      {(canView('walk-in-booking') || canView('bookings')) && (
      <Link
        className="admin-nav-item"
        to={'/admin-bookings'}
      >
        <IoTicket />
        Add Booking
      </Link>
      )}
    </>
  );

  // get local storage data.
  const localdata = localStorage.getItem('sundorbonBookingUserDetails');
  const Name = JSON.parse(localdata)?.Name || '';
  const Email = JSON.parse(localdata)?.Email || '';

  return (
    <aside className='admin-sidebar'>
      <div className='admin-sidebar-brand'>
        <Link to='/' onClick={() => setShowAside(false)}>
          <img src={logo} alt='Sundorbon' />
        </Link>
      </div>
      <div className='admin-sidebar-user'>
        <div className='min-w-0 flex-1'>
          <p className='text-[10px] font-bold uppercase tracking-[0.14em] text-orange-300/90'>
            Admin
          </p>
          <p className='text-sm font-semibold truncate mt-0.5'>{Name || 'Admin'}</p>
          <p className='text-xs text-white/60 truncate'>{Email}</p>
        </div>
        <div className='flex flex-col items-end gap-1.5 shrink-0'>
          <NotificationBell variant='dark' />
          <SignalRConnectionPill compact />
        </div>
      </div>
      <nav className='admin-sidebar-nav'>{renderNav()}</nav>

      <div className='lg:hidden'>
        <div className='admin-mobile-bar'>
          <ToggleButton
            value={toggleBtnChecked}
            showAside={showAside}
            eventHandle={ToggleEventHandler}
          />
          <div className='flex items-center gap-2'>
            {GetLocalStorageUserId() ? (
              <>
                <SignalRConnectionPill compact />
                <NotificationBell variant='dark' />
                <button type='button' onClick={logoutHandle} className='text-sm'>
                  Logout
                </button>
              </>
            ) : (
              <Link to={'/login'}>Login</Link>
            )}
          </div>
        </div>
        <div
          className={`admin-mobile-drawer ${
            showAside ? 'is-open' : 'is-closed'
          }`}
        >
          <ul>{renderNav()}</ul>
        </div>
      </div>
    </aside>
  );
};

export default AsideNav;
